import React, { Component } from 'react';
import { withLocalize, Translate } from 'react-localize-redux';
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip } from 'recharts';
import OldStyleSection from '../../common/oldStyleSection';
import OldStyleTableWithHistory from '../../common/oldStyleTableWithHistory';

const COLORS = {
    green: "#00c59e",
    darkGreen: "#9fd300",
    yellow: "#fae300",
    darkyellow: "#f5b31c",
    orange: "#f08635",
    tomato: "#eb634b",
    red: "#e74360",
    pink: "#cc597b",
    violet: "#ae7199",
    darkViolet: "#8991bd",
    blue: "#61b4e4",
    gray: "#aaaaaa"
}

class EconomicGroupStructure extends Component {
    render() {
        if (!this.props.data) { return null };
        return (
            <OldStyleSection name={this.props.translate("Report.EconomicGroup.GroupStructure")} hasData isBold isOpen={false}>
                {this.chartAndTable(this.props.data.legalForms, "Report.CompanyIdentification.LegalForm", 0)}
                {this.chartAndTable(this.props.data.regions, "Common.Region", 1)}
                {this.chartAndTable(this.props.data.mainActivities, "Report.EconomicGroup.PrevailingActivity", 2)}
            </OldStyleSection>
        )
    }

    chartAndTable = (item, translationKey, index) => {
        if (item === null) { return null; }
        return (
            <>
                <div className={`columns ${index % 2 === 0 ? "even" : "odd"}`}>
                    <div className="column is-6">
                        <span className="underlined-title-wrapper">
                            <span className="underlined-title">
                                <Translate id={translationKey} />
                            </span>
                        </span>
                        <ResponsiveContainer width="99%" height={350}>
                            <PieChart margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                                <Pie paddingAngle={2.5} data={item} dataKey="count" nameKey="label" cx="50%" cy="50%" innerRadius="60%"
                                    outerRadius="80%" fill="#8884d8">
                                    {item.map((entry, i) => <Cell key={i} fill={this.getChartColor(i)} />)}
                                </Pie>
                                <Tooltip content={<CustomTooltip />} wrapperStyle={tooltipStyle} />
                            </PieChart>
                        </ResponsiveContainer>
                    </div>
                    <div className="column is-6">
                        <OldStyleTableWithHistory tableColumns={4} stripped resolveExpanded={this.props.resolveExpanded}
                            actualData={item.map((item, i) => ({ ...item, index: i}))}
                            classNames={{ "ess-chart-table": true }}
                            head={() => <thead>
                                <tr>
                                    <th style={{ width: "2.5em" }}></th>
                                    <th><Translate id={translationKey} /></th>
                                    <th style={{ width: "8em" }}><Translate id="Common.Share" /></th>
                                    <th style={{ width: "8em" }}><Translate id="Search.Common.Count" /></th>
                                </tr>
                            </thead>}
                            actualRow={(r) => <tr key={r.index} className="colorize">
                                <td><span className="small-circle" style={{ background: this.getChartColor(r.index) }} ></span></td>
                                <td>{r.label}</td>
                                <td>{Math.round(r.share, 2)}%</td>
                                <td>{r.count}</td>
                            </tr>}
                        />
                    </div>
                </div>
            </>
        )
    }

    getChartColor(i) {
        return Object.keys(COLORS).map(x => COLORS[x])[i];
    }
}

const tooltipStyle = {
    textAlign: 'center',
    fontSize: '0.8em',
    padding: "0.35em 2em",
    background: "#FFF",
    border: "1px solid #DEDEDE",
    boxShadow: "0px 1px 4px 1px rgba(68, 71, 73, 0.1)",
    WebkitBoxShadow: "0px 1px 4px 1px rgba(68, 71, 73, 0.1)"
}
const CustomTooltip = ({ active, payload, label }) => {
    if (active) {
        const pl = payload[0].payload;
        return (
            <div className="payment-chart-tooltip">
                <p style={{ fontWeight: "600", fontSize: "1.2em" }}>{Math.round(pl.share, 2)}% ({pl.count})</p>
                <div style={{ fontSize: "1em" }}>{pl.label}</div>
            </div>
        );
    }

    return null;
};

export default withLocalize(EconomicGroupStructure);
